// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"6":"1bb61021","589":"e21a2814","916":"4e3e9bae","945":"9c81cba0"}[chunkId] + ".css";
};